import "./caseOverview.css";
import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { getDashboardStats } from "../../../services/dashboardService";

export default function CaseOverview() {
    const { globalUser } = useAuth();

const [stats, setStats] = useState({
  pendingCases: 0,
  disposedCases: 0,
  inProgressCases: 0,
  onHoldCases: 0,
  totalCases: 0,
});

useEffect(() => {
  if (!globalUser?.uid) return;

  const loadStats = async () => {
    const data = await getDashboardStats(globalUser.uid);
    setStats(data);
  };

  loadStats();
}, [globalUser]);

const pendingPercent =
  stats.totalCases > 0
    ? Math.round((stats.pendingCases / stats.totalCases) * 100)
    : 0;

const disposedPercent =
  stats.totalCases > 0
    ? Math.round((stats.disposedCases / stats.totalCases) * 100)
    : 0;

const progressPercent =
  stats.totalCases > 0
    ? Math.round((stats.inProgressCases / stats.totalCases) * 100)
    : 0;

const holdPercent =
  stats.totalCases > 0
    ? Math.round((stats.onHoldCases / stats.totalCases) * 100)
    : 0;

    const chartBackground = `conic-gradient(
  #7C6CF5 0% ${pendingPercent}%,
  #7FD3A4 ${pendingPercent}% ${pendingPercent + disposedPercent}%,
  #79B8F3 ${pendingPercent + disposedPercent}% ${
    pendingPercent + disposedPercent + progressPercent
  }%,
  #F7D96D ${
    pendingPercent + disposedPercent + progressPercent
  }% 100%
)`;

  return (
    <div className="dashboard-panel">

      <div className="panel-header">
        <div className="panel-title">
          <span>Case Overview</span>
        </div>
      </div>
      <div className="case-overview-content">

    <div className="case-chart"
    style={{
    background: chartBackground,
  }}>
        <div className="chart-center">
            <h2>{stats.totalCases}</h2>
            <p>Total Cases</p>
        </div>
    </div>

    <div className="case-stats">

        <div className="case-stat">
            <span className="dot pending"></span>
            <span>Pending</span>
            <strong>{stats.pendingCases} ({pendingPercent}%)</strong>
        </div>

        <div className="case-stat">
            <span className="dot disposed"></span>
            <span>Disposed</span>
            <strong>{stats.disposedCases} ({disposedPercent}%)</strong>
        </div>

        <div className="case-stat">
            <span className="dot progress"></span>
            <span>In Progress</span>
            <strong>{stats.inProgressCases} ({progressPercent}%)</strong>
        </div>

        <div className="case-stat">
            <span className="dot hold"></span>
            <span>On Hold</span>
            <strong>{stats.onHoldCases} ({holdPercent}%)
</strong>
        </div>

    </div>

</div>

    </div>
  );
}